import { ExistsTransformation } from 'app/model/dataflow/existstransformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from '../../expression.util';
import { ExistsPlainObject } from 'worker/app-workers/shared/plainObjects/exists.plainObject';
import { MultiInputsTransformConvertor } from './multiInputsTransform.convertor';
import { IResourceContext } from 'shell-models-lib';

export class ExistsConvertor extends MultiInputsTransformConvertor {
    private get existsTransform(): ExistsTransformation {
        return this.transformation as ExistsTransformation;
    }

    private get existsObject(): ExistsPlainObject {
        return this.transformObject as ExistsPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        if (!!this.existsObject.customExpression) {
            this.existsTransform.customExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                this.existsObject.customExpression
            );
            this.existsTransform.useCustomExpression = true;
        }

        if (this.existsObject.configs.has('negate')) {
            this.existsTransform.negate = this.existsObject.configs.get('negate') === 'true';
            this._handledConfigs.push('negate');
        }

        super.postConvert();
        return this.transformation;
    }
}
